import * as z from "zod";

export const enableRecoverBilling = {
  name: "enableRecoverBilling" as const,
  input: z.object({}),
  output: z.object({
    success: z.boolean(),
    confirmationUrl: z.string().optional(),
    /**
     * When `success` is false and we can safely surface a reason to the
     * merchant UI, this carries a short message. Stack traces and internal
     * details stay in server logs — this is user-facing copy.
     */
    errorMessage: z.string().optional(),
  }),
};
